import Cookies from 'js-cookie';
import apiClient from 'services/_infra/apiClient';
import { tryCache } from 'services/_infra/requestCache';

export async function getDetailedMarine7() {
  try {
    const res = await tryCache(
      `getDetailedMarine7-${Cookies.get('latitude')}-${Cookies.get('longitude')}`,
      () =>
        apiClient.post('/getDetailedMarine7', {
          city: Cookies.get('city'),
          state: Cookies.get('state'),
          longitude: Cookies.get('longitude'),
          latitude: Cookies.get('latitude'),
        }),
    );
    return res;
  } catch (error) {
    console.error('getDetailedMarine7 failed.', error);
  }
}

export async function getBuoyConditions() {
  try {
    const res = await tryCache(
      `getBuoyConditions-${Cookies.get('latitude')}-${Cookies.get('longitude')}`,
      () =>
        apiClient.post('/getBuoyData', {
          city: Cookies.get('city'),
          state: Cookies.get('state'),
          longitude: Cookies.get('longitude'),
          latitude: Cookies.get('latitude'),
          limit: 1000,
        }),
    );
    return res;
  } catch (error) {
    console.error('getBuoyData failed.', error);
  }
}

export async function getTideTable() {
  try {
    const res = await tryCache(
      `getTideTable-${Cookies.get('latitude')}-${Cookies.get('longitude')}`,
      () =>
        apiClient.post('/getTideData', {
          city: Cookies.get('city'),
          state: Cookies.get('state'),
          longitude: Cookies.get('longitude'),
          latitude: Cookies.get('latitude'),
        }),
    );
    return res;
  } catch (error) {
    console.error('getTideData failed.', error);
  }
}
